import { createAction } from '@reduxjs/toolkit';
import { IJob } from '../../../../dto';
import { ACT_SET, MN_JOBS, TYPE_ELEMENT } from '../../../../common';

export const setJob = createAction<IJob>(
  `${MN_JOBS}/${TYPE_ELEMENT}/${ACT_SET}`,
);
